/**
 * Options for Data Matrix.
 */
enum DataMatrix {
  /** Resolution automatically determined (default) */
  DM_DMRE = 101,
  /** Square Data Matrix */
  DM_SQUARE = 100
}

export default DataMatrix
